'use strict';

const SoaModel     = require('bunsen/models/SoaModel');
const Measurement  = module.exports = SoaModel.extend();

const _            = require('underscore');
const Backbone     = require('dibs-backbone');

_.extend(Measurement, {
    units: {
        IN: 'IN',
        MM: 'MM',
        CM: 'CM'
    }
});

_.extend(Measurement.prototype, {
    relations() {
        return [
            {
                key: 'weight',
                type: Backbone.One,
                relatedModel: SoaModel
            },
            {
                key: 'size',
                type: Backbone.One,
                relatedModel: SoaModel
            }
        ];
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/Measurement.es.js